import React from 'react'
import Celestial from './Com_1/com_1'
import CimSection from './Com_2/com_2';
import CimImageSection from './Com_3/com_3';
import AboutSection from '../../Components/TopHeader/topheader';
import VisionMission from './Com_4/com_4';
import WhyChoose from './Com_5/com_5';
import HeroCarrerReport from '../HomePages/carrerReport/carrerReport';
import AppointmentForm from '../HomePages/homeappointment/homeappointment';
import MembershipHero from '../HomePages/joinushomepage/joinushomepage';
import TestimonialSlider from '../HomePages/hometestimonials/hometestimonials';
// import VisionMission from './component1/com_4';
// import WhyChoose from './component1/com_5';
 const Aboutmain =() => {
  return (
    <div>

        <AboutSection 
          
            title = "ABOUT US"
            description = "We provide personalized astrology consultations, chart readings, and remedies based on planetary alignments to guide you toward clarity and success."

        />
        < Celestial />

        < CimSection />
        <  CimImageSection />
        <VisionMission />
        <WhyChoose />
        <HeroCarrerReport />
        <AppointmentForm />
        <MembershipHero />
        <TestimonialSlider />
        {/* < VisionMission /> */}
        {/* <  WhyChoose/> */}
    </div>
  );
};

export default Aboutmain;